import { apiUrl, fetchJson } from '../../apiBase';

function withParams(schoolId, suffix, options = {}) {
  const params = new URLSearchParams();
  Object.entries(options).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') params.set(key, String(value));
  });
  const query = params.toString();
  return apiUrl(`/admin/teacher-home/${encodeURIComponent(schoolId)}/student-activities${suffix}${query ? `?${query}` : ''}`);
}

async function getJson(url) {
  const response = await fetchJson(url);
  if (!response.ok) throw new Error('Öğrenci etkinlikleri alınamadı.');
  return response.json();
}

export const getStudentActivities = (schoolId, options) => getJson(withParams(schoolId, '', options));
export const getStudentActivityDetail = (schoolId, studentId, options) => getJson(
  withParams(schoolId, `/${encodeURIComponent(studentId)}`, options)
);
